import { render, staticRenderFns } from "./IconPreview.vue?vue&type=template&id=2509e30a&scoped=true"
import script from "./IconPreview.vue?vue&type=script&lang=ts"
export * from "./IconPreview.vue?vue&type=script&lang=ts"
import style0 from "./IconPreview.vue?vue&type=style&index=0&id=2509e30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2509e30a",
  null
  
)

export default component.exports